import PostApprovePageView from "../../components/community/post_approve_pageview";

const PendingArticlesScreen = () => {
    return (
        <PostApprovePageView isPost={false} />
    )
}

export default PendingArticlesScreen;